// @ts-check

import { Image as BaseImage } from '@react-pdf/renderer';
import React from 'react';
import BookmarkIcon from '../../components/BookmarkIcon';
import {
  Box,
  Company,
  Flex,
  Product,
  QRCode,
  Registration,
  Image,
  Text,
  Title,
} from '../../pdf-design-system';
import roussillonLogo_small from './images/roussillonLogo_small.jpeg';
import { theme } from './RoussillonCatalog';
import { PageLayout } from './RoussillonCatalog';

export default function RoussillonCatalogProfilePage({
  bleed = 3,
  page,
  theme,
  baseUrl,
}) {
  const { registration } = page;
  return (
    <PageLayout theme={theme} bleed={bleed}>
      <PageBody bleed={bleed}>
        <ExhibitorHeader registration={registration} />
        <Box style={{ marginTop: 10 }}>
          <Title style={{ marginBottom: 10 }}>About Us</Title>
          <Text>{registration.profile.shortDescription}</Text>
        </Box>
        <Box style={{ flexGrow: 1 }} />
        <Title style={{ marginBottom: 10, marginTop: 15 }}>Contact</Title>
        <Flex>
          <Box style={{ width: '50%' }}>
            <Text>{registration.profile.street}</Text>
            <Text>
              F-{registration.profile.postalCode} {registration.profile.city}
            </Text>
          </Box>
          <Box style={{ width: '50%' }}>
            {registration.profile.email && (
              <Text>Email: {registration.profile.email}</Text>
            )}
            {registration.profile.website && (
              <Text>
                Website: {registration.profile.website.replace(/\/$/, '')}
              </Text>
            )}
            {registration.attendingContacts?.[0]?.fullName && (
              <Text>
                Contact: {registration.attendingContacts?.[0]?.fullName}
              </Text>
            )}
          </Box>
        </Flex>
      </PageBody>

      <Flex
        style={{
          position: 'absolute',
          // backgroundColor: theme.colors.accent,
          paddingHorizontal: `${15 + bleed * 2}mm`,
          bottom: 0,
          left: 0,
          right: 0,
          height: `${20 + bleed}mm`,
          paddingBottom: `${bleed}mm`,
          alignItems: 'center',
        }}
      >
        <BaseImage src={roussillonLogo_small} style={{ marginRight: 3 }} />
        <Box>
          <Text variant="light">View our online tasting catalog at </Text>
          <Text variant="base">{baseUrl}</Text>
        </Box>
      </Flex>
    </PageLayout>
  );
}

function PageBody({ bleed, children, debug = false }) {
  return (
    <Box
      style={{
        paddingHorizontal: `${10 + bleed}mm`,
        paddingTop: `${10 + bleed}mm`,
        paddingBottom: '25mm',
        // height: '216mm',
        position: 'relative',
        flexGrow: 1,
      }}
      debug={debug}
    >
      {children}
    </Box>
  );
}

function ExhibitorHeader({ registration }) {
  return (
    <Box style={{ position: 'relative', height: 210 }}>
      <Image
        crop="fill"
        src={registration.profile.mainImage.url}
        width={347}
        height={160}
        trim
        gravity="faces"
        style={{ padding: 0, margin: 0 }}
      />
      <Flex
        style={{
          backgroundColor: 'white',
          height: 90,
          width: 90,
          border: 1,
          borderColor: '#CCC',
          alignItems: 'center',
          borderRadius: 5,
          justifyContent: 'center',
          position: 'absolute',
          top: 120,
          left: 30,
        }}
      >
        <Company.ProfileLogo
          companyProfile={registration.profile}
          height={70}
          width={70}
          // gravity={'north_west'}
        />
      </Flex>
      <Box style={{ marginLeft: 135, marginTop: 5 }}>
        <Text>{registration?.stand?.name || 'Table 34'}</Text>
        <Title style={{ marginBottom: 3, fontSize: 18 }}>
          {registration.profile.name}
        </Title>
      </Box>
    </Box>
  );
}
